// 参数配置
<template>
<v-card title="参数配置">
  <div>
    <vxe-grid
      v-bind="xGridOptions"
      size="mini"
      stripe
      highlight-current-row
      highlight-hover-row
      ref="xTable"
      :data="tableData"
    >
      <template v-slot:cz="{ row }">
        <span>
          <span>
            <a class="link" @click="add(row)" title="修改">
              <v-icon type="edit"></v-icon>
            </a>
          </span>
        </span>
      </template>
      <template v-slot:empty>
        <span style="color: red;">
         <p>未搜索到结果！</p>
        </span>
      </template>
    </vxe-grid>
  </div>
  </v-card>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      type: [],
      state: [],
      tableData: [],
      xGridOptions: {
        resizable: true,
        height: 408,
        headerAlign: "center",
        checkboxConfig: {
          labelField: "id",
          highlight: true,
          range: true
        },
        editConfig: {
          trigger: "",
          mode: "row",
          showStatus: true
        },
        columns: [
          {
            type: "seq",
            title: "序号",
            width: 70,
            align: "center"
          },
          {
            field: "p_dm",
            title: "参数代码"
          },
          {
            field: "p_bz",
            title: "参数名称"
          },
          {
            field: "p_val",
            title: "参数值"
          },
          {
            field: "xy_bz",
            title: "状态",
             slots: {
              default: ({ row, column }) => {
                let xy_bz = row.xy_bz == '1' ? "启用" : "禁用";
                return [<span>{xy_bz}</span>];
              },
            },
          },
          {
            field: "cz",
            title: "操作",
            align: "center",
            slots: {
              default: "cz"
            }
          }
        ]
      }
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      axios
        .get(
          "api/system/qxgl/get-cs-list"
        )
        .then(res => {
          this.tableData = res.data.data;
        });
    },
    add: function(row) {
      var id = row==""?"":row.id;
      xadmin.open("修改参数配置", "/xtcsadd?id=" + id, "900", "350","",this.findList);
    },
  }
};
</script>


<style>
.grid-demo .gutter-example .ant-row > div {
  background: transparent;
  border: 0;
}

.grid-demo .gutter-box {
  padding: 5px 0;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/view/xtgl/xtcs.vue